module.exports = __webpack_public_path__ + "img/197005.2bb0f5d2.svg";